import { Box, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import axiosInstance from '../../../api/axiosInstance'
import dentalImage from '../../../assets/DentalAppointment.png'
import DentalClinicCard from './DentalClinicCard'


function DentalClinics() {
  const [dentalData, setDentalData] = useState([])
  const language = useSelector((state) => state.language.language)

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/get-all-dentals")
      console.log(response)
      if(response?.status === 200){
        setDentalData(response?.data?.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  console.log(dentalData)

  useEffect(() => {
      fetchData()
  }, [])



  return (
    <>
    <Box sx={{display : 'flex', justifyContent : 'center'}}>
    <Box sx={{width : '90%'}}>
          <Box sx={{mt : 10, mb : 5}}>
          <Box
             sx={{
               width : '100%',
               height : '400px',
               backgroundImage : `url(${dentalImage})`,
               backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              borderRadius : '24px',
              overflow: "hidden",
               }} />
          </Box>

          <Divider sx={{mb : 4}}/>
          <Box sx={{display : 'flex', justifyContent : {xs : 'space-between', sm : 'center', md : 'start'}, flexWrap : 'wrap', mb : 5, gap : {xs : 4, lg : 8}}}>
            {dentalData.map((data) => (
              <DentalClinicCard 
                  key={data?._id} 
                  id={data?._id}
                  title={data?.title?.[language]}
                  description={data?.description?.[language]}
                  image={`${process.env.REACT_APP_FILE_PATH}/${data?.img?.filename}`}
                  location={data?.location}
                  contact={data?.contact}
                  />
            ))}
          </Box>
    </Box>
    </Box>
    </>
  )
}

export default DentalClinics